<script setup lang="ts">
const { searchKeyword, isLoading, legalAreaFacetOptions, legalAreaSelected, toggleLegalArea, searchLegalArea } = useAuthorFilters()
</script>

<template>
  <aside aria-label="Filtervalg" class="flex flex-col gap-m w-[369px] pt-l">
    <div class="flex flex-col gap-s">
      <span aria-hidden="true" class="title-s font-bold">
        Filtrer på forfatter
      </span>
      <FormSearchInput
        id="author-name-filter"
        v-model="searchKeyword"
        resettable
        shape="square"
        size="medium"
        label="Filtrer på forfatter"
      />
    </div>

    <FilterSkeleton v-if="isLoading" />

    <div v-if="legalAreaFacetOptions.length" class="flex flex-col gap-s">
      <span class="text-small font-bold">Rettsområde</span>
      <FilterFacetList
        v-model:search="searchLegalArea"
        class="gap-s"
        label="Rettsområde"
        name="authorLegalArea"
        expand-noun="rettsområder"
        :options="legalAreaFacetOptions"
        :selected="legalAreaSelected"
        :toggle="toggleLegalArea"
      />
    </div>
  </aside>
</template>